module.exports = __webpack_public_path__ + "img/org-light.e2a77a01.svg";